import { render, staticRenderFns } from "./InputRadioGroup.vue?vue&type=template&id=d93d8e9c&"
import script from "./InputRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./InputRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports